import { onBeforeUnmount } from 'vue'

export default function useEventListeners() {
    let eventListeners = []

    const listen = (element, event, handle, options) => {
        element.addEventListener(event, handle, options)

        eventListeners.push({ element, event, handle })
    }

    onBeforeUnmount(() => {
        eventListeners.forEach((hook) => {
            hook.element.removeEventListener(hook.event, hook.handle)
        })
    })

    return { listen }
}
